export default __webpack_public_path__ + "static/lb1-ea5791051c2928cd1f8e4393ee854687.webp";